import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { StringContextType } from "@faire/web-api--source/faire/translator/StringContextType";
import brandPortalAccountRoute from "@faire/web-api--source/routes/brand-portal/account";
import React from "react";

import { TaxForm1099IA } from "./instantAnswersComponents/payments/TaxForm1099IA";

export const taxForm1099: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => getAnswer(context, strictLocalize).getTitle(),
  descriptionBuilder: (context) =>
    getAnswer(context, strictLocalize).getDescription(),
  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const getAnswer = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => TAX_FORM_1099_TITLE(context, strictLocalize),
    getDescription: () => TAX_FORM_1099_DESCRIPTION(context),
  };
};

const TAX_FORM_1099_TITLE = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
) => {
  const { brand } = context;
  if (brand?.based_in === "USA") {
    return strictLocalize({
      defaultMessage: "Accessing your 1099 tax form",
      description: {
        text: "Title for the 'Accessing your 1099 tax form' instant answer",
      },
    });
  }
  return strictLocalize({
    defaultMessage: "1099-K Form Qualification Criteria",
    description: {
      text: "Title for the '1099-K Form Qualification Criteria' instant answer",
    },
  });
};

const getPrimaryCTA: CtaBuilderFn = (context, strictLocalize) => {
  const { brand } = context;
  if (brand?.based_in === "USA") {
    return {
      label: strictLocalize({
        defaultMessage: "View Export & Taxes",
        description: {
          text: "CTA button to go to the tax information page",
          stringDescriptors: [StringContextType.CALL_TO_ACTION],
        },
      }),
      getLink: () => brandPortalAccountRoute({ tab: "export-and-taxes" }),
    };
  }
  return undefined;
};

const TAX_FORM_1099_DESCRIPTION = (context: InstantAnswerContext) => {
  const { brand } = context;
  return <TaxForm1099IA brand={brand} />;
};
